<template>
  <div class="classify">
    <app-subHeader :subTitle="this.subTitle"></app-subHeader>
    <div class="container">
      <p class="conTitle">MT4&MT5交易规则</p>
      <p class="conTitle">伦敦金/银买卖规则列表</p>
      <p class="conText">
        香港金盛贵金属有限公司是香港黄金交易所AA类会员第047号会员，是香港黄金交易所认可的伦敦金和伦敦银交易商。现可在香港金盛贵金属开立优惠账户，最低可交易0.01手，0佣金。
      </p>
    </div>
    <!-- 	<div class="container">
			<p class="conTitle">伦敦金/银买卖规则列表</p>
			<table class="conTable">
				<thead>
					<tr>
	                    <td class="w2"></td>
	                    <td>金盛盈富</td>
	                    <td>金盛贵金属</td>
	                </tr>
				</thead>
	            <tbody>
	                
	                <tr>
	                    <td>产品</td>
	                    <td  colspan="2">伦敦金/银</td> 
	                </tr>
	                <tr>
	                    <td>合约单位（每手）</td>
	                    <td colspan="2">伦敦金100盎司/伦敦银5000盎司</td>
	                </tr>
	                <tr>
	                    <td>最低价格波幅 </td>
	                    <td colspan="2">0.01美元</td>
	                </tr>
	                <tr>
	                    <td>交易保证金 </td>
	                    <td> 800美元/手   </td>
	                    <td> 合约价值的2% </td>
	                </tr>
	                <tr>
	                    <td>点差优惠</td>
	                    <td>30美元/手 </td>
	                    <td>26美元/手 </td>
	                </tr>
	                <tr>
	                    <td>每次下单手数</td>
	                    <td>伦敦金：0.01-50手 <br>伦敦银：0.01-20手</td>
	                    <td>伦敦金：0.01-20手<br>伦敦银：0.01-20手  </td>
	                </tr>
	                <tr>
	                    <td>点差</td>
	                    <td colspan="2">伦敦金0.12美元/伦敦银0.03美元</td>
	                </tr>
	                <tr>
	                    <td>强制平仓</td>
	                    <td>净值/交易保证金≤100%</td>
	                    <td>净值/交易保证金≤30%</td>
	                </tr>
	                <tr>
	                    <td>佣金</td>
	                    <td colspan="2">免收佣金（0佣金）</td>
	                </tr>
	                <tr>
	                    <td>持仓过夜利息</td>
	                    <td colspan="2">买入：-1.25%； 卖出：-1.25（此处为年利率）</td>
	                </tr> 
	                <tr>
	                    <td>交易时间</td>
	                    <td colspan="2" class="textLeft"> 夏令交易时间：<br>周一上午7:00至周六凌晨3:00，国际节假日休市<br>夏令暂停时间：<br>星期二至星期五上午05:00至06:00<br>冬令交易时间：<br>周一上午7:00至周六凌晨4:00，国际节假日休市<br>冬令暂停时间：<br>星期二至星期五上午06:00至07:00</td>
	                </tr>
	            </tbody>
            </table>	
		</div> -->
    <div class="container">
      <p class="conTitle">伦敦金/银买卖规则列表</p>
      <table class="conTable">
        <thead>
          <tr>
            <td class="th">金盛产品</td>
            <td><span class="color">伦敦金</span></td>
            <td><span class="color">伦敦银</span></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="th">合约单位(每手)</td>
            <td><span class="color">100</span>盎司/手</td>
            <td><span class="color">5000</span>盎司/手</td>
          </tr>
          <tr>
            <td class="th">单笔最大交易量</td>
            <td colspan="2"><span class="color">20</span>手</td>
          </tr>
          <tr>
            <td class="th">单笔最小交易量</td>
            <td colspan="2"><span class="color">0.01</span>手</td>
          </tr>
          <tr>
            <td class="th">点差</td>
            <td><span class="color">0.12美元</span>/盎司</td>
            <td><span class="color">0.04美元</span>/盎司</td>
          </tr>
          <tr>
            <td class="th">交易保证金</td>
            <td colspan="2"><span class="color">开仓时总合约价值的2%</span></td>
          </tr>
          <tr>
            <td class="th">最低开户保证金</td>
            <td colspan="2"><span class="color">200</span>美元</td>
          </tr>
          <!-- <tr>
              <td class="th">维持保证金</td>
              <td colspan="2"><span class="color">300</span>美元/手</td>
          </tr> -->
          <tr>
            <td class="th">锁仓保证金</td>
            <td colspan="2">锁仓订单保证金总和的二分之一(50%)</td>
          </tr>
          <tr>
            <td class="th">强制平仓</td>
            <td colspan="2">
              2%及1000美元档：平日 20%，周末/假日休市前100%<br>800美元档：平日30%，周末/假日休市前130% <img
                style="position: relative; bottom: 0.05rem; width: 0.47rem"
                src="./img/warn-icon-APP.png"
                alt=""
              />
            </td>
          </tr>
          <tr>
            <td class="th">佣金</td>
            <td colspan="2">免收佣金（0佣金）</td>
          </tr>
          <tr>
            <td class="th">过夜所需利息</td>
            <td colspan="2">
                伦敦金买入/卖出1.75% <br>  
                伦敦银买入/卖出2.15%    
            </td>
          </tr>
          <tr>
            <td class="th">系统结算时间</td>
            <td colspan="2">
              夏令结算时间：周二至周五，每天上午5:00至6:00
              <br />冬令结算时间：周二至周五，每天上午6:00至7:00
            </td>
          </tr>
          <tr>
            <td class="th">交易时间</td>
            <td colspan="2">
              夏令交易时间：周一上午6:01至周六凌晨4:45<br />冬令交易时间：周一上午7:01至周六凌晨5:45<br />
              国际节假日休市请留意官网公告
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="box">
      <div class="group" v-for="(item, index) in conList" :key="index">
        <div class="flex headline" @click="item.tab = !item.tab">
          <span class="title">
            <i>{{ index + 1 }}</i> {{ item.tag }}</span
          >
          <i class="arrow"></i>
        </div>
        <div class="detail" v-show="item.tab" v-html="item.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import subHeader from "../header/SubHeader";
export default {
  name: "classify",
  data() {
    return {
      subTitle: "交易规则",
      show: false,
      conList: [
        {
          tag: "注资",
          tab: false,
          desc: "Ⅰ.客户可根据本公司网站上提供之注资方式为客户本人之交易账户存入资金。<br>Ⅱ.除非本公司核实确认收到客户之注资资金，否则本公司将无法为客户办理注资。<br>Ⅲ.如客户通过银行汇款方式进行注资而产生的手续费用均由客户本人自行承担。<br>Ⅳ.香港金盛贵金属无法为互联网的连接状态做出担保，客户同意不因无法在网页及时注资而造成的损失追究香港金盛贵金属的责任。<br>Ⅴ.客户非本人存款安排<br>为了保障客户资金安全，防止不良客户进行洗黑钱等违法活动，香港金盛贵金属作出以下规定：<br>香港金盛贵金属不接受非本人（第三方）银行账户入金。 香港金盛贵金属保留调查核实和拒绝客户以非本人（第三方）户口入款的权利。本公司若发现客户使用非本人姓名的银行账户入金，香港金盛贵金属有权即时冻结客户账户进行调查，禁止其账户进行一切交易。本公司有权对客户账户进行以下处理：<br>1. 若客户账户从未进行任何交易，香港金盛贵金属将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户   ；<br>2. 若客户账户已进行任何交易，香港金盛贵金属将由第三方存款起的所有交易及优惠 (包括点差回赠，赠金等优惠)取消。并将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户中；<br>3. 对于以上情况，香港金盛贵金属可依据酌情权决定向任何相关监管机构或执法机构报告有关事件。同时,本公司有权即时冻结相应客户账户并禁止其进行一切交易。<br>",
        },
        {
          tag: "取款",
          tab: false,
          desc: "为保障客户与本公司双方权益，客户在取款时，需留意以下事宜：<br> Ⅰ.首次取款前必须向本公司提交客户本人之有效身份证及银行卡影印本，否则本公司不受理客户之取款申请。<br>  Ⅱ. 取款时间：周一至周五每天08:00-18:00，节假日取款时间以官网通知为准。<br>  Ⅲ.客户申请单笔取款≥50美元所产生之汇款手续费用均由本公司承担。<br>  Ⅳ.客户申请单笔取款＜50美元，本公司将收取当中3美元作为汇款手续费。<br>   Ⅴ.客户申请首次取款时之交易量对应保证金少于注资金额的50%（或完全没有进行过交易），或在一个取款审核周期内交易量对应保证金少于该周期内注资金额的50%（或完全没有进行过交易），本公司将收取取款金额之6%作为汇款手续费。<br>  Ⅵ.客户在每个交易日内首2笔取款均为免费，第3笔开始每笔将会收取6%作为汇款手续费。<br>  Ⅶ.本公司将于收到取款申请起开始办理，按流程预计在2小时内处理并将该笔款项汇出。<br>  Ⅷ.鉴于第三方原因，银行处理款项速度非本公司可控制及准确预计。因此客户可能会有无法在2小时内收到所提取款项的情况。客户同意不因款项到账时间超出2小时而追究香港金盛贵金属的责任。<br>  Ⅸ.到账币种取决于客户所持收款银行卡所在地区，大陆地区银行卡客户到账币种为人民币，香港地区银行卡客户到账币种为港币，其它地区客户到账币种为美元。<br>  Ⅹ.香港金盛贵金属保留对于注资及取款手续费的所有解释权和决定权。<br>",
        },
        {
          tag: "点差调整 ",
          tab: false,
          desc: "Ⅰ.客户可根据本公司网站上提供之注资方式为客户本人之交易账户存入资金。<br>Ⅱ.除非本公司核实确认收到客户之注资资金，否则本公司将无法为客户办理注资。<br>Ⅲ.如客户通过银行汇款方式进行注资而产生的手续费用均由客户本人自行承担。<br>Ⅳ.香港金盛贵金属无法为互联网的连接状态做出担保，客户同意不因无法在网页及时注资而造成的损失追究香港金盛贵金属的责任。<br>Ⅴ.客户非本人存款安排<br>为了保障客户资金安全，防止不良客户进行洗黑钱等违法活动，香港金盛贵金属作出以下规定：<br>香港金盛贵金属不接受非本人（第三方）银行账户入金。 香港金盛贵金属保留调查核实和拒绝客户以非本人（第三方）户口入款的权利。本公司若发现客户使用非本人姓名的银行账户入金，香港金盛贵金属有权即时冻结客户账户进行调查，禁止其账户进行一切交易。本公司有权对客户账户进行以下处理：<br>1. 若客户账户从未进行任何交易，香港金盛贵金属将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户   ；<br>2. 若客户账户已进行任何交易，香港金盛贵金属将由第三方存款起的所有交易及优惠 (包括点差回赠，赠金等优惠)取消。并将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户中；<br>3. 对于以上情况，香港金盛贵金属可依据酌情权决定向任何相关监管机构或执法机构报告有关事件。同时,本公司有权即时冻结相应客户账户并禁止其进行一切交易。<br> ",
        },
        {
          tag: "点差回赠 ",
          tab: false,
          desc: " 交易单在平仓后会享有该单相应的点差回赠，点差回赠会直接添加到交易账号中，客户可以选择用于继续投资交易或取款。点差回赠默认是平仓后即时返还。",
        },
        {
          tag: " 挂单及止损获利设置的有效期",
          tab: false,
          desc: "挂单及止损获利设置的有效期最长为1个交易周，周末休市后所有未建仓的挂单及未执行的止损获利设置将全部取消。如有需要，客户可在周一开市后重新设置。<br>注:国际假日需要休市或非农当天，所有未建仓的挂单及未执行的止损/获利设置可能被取消。 ",
        },
        {
          tag: " 保证金",
          tab: false,
          desc: "现货黄金合约交易保证金例子:<br>1手黄金交易保证金 :<br>1200美元(开仓价) × 100(合约单位) × 2%(保证金要求比率) × 1(手数) = 2400美元<br>现货白银合约交易保证金例子:<br>1手白银交易保证金:<br>14美元(开仓价) × 5000(合约单位) × 2%(保证金要求比率) × 1(手数) = 1400美元 ",
        },
        {
          tag: "强制平仓 ",
          tab: false,
          desc: "  (1)在周一至周五交易时段内，若客户账户凈值小于或等于订单所需保证金的20%时，交易平台会从亏损金额最多的交易单开始强制平仓，直到保证金比例恢复20%以上。  <br>(2)周末及假日过市时，若客户账户凈值小于或等于订单所需保证金的100%时，交易平台会从亏损金额最多的交易单开始强制平仓，直到保证金比例恢复100%以上。 由于周末及假日休市和周一开市期间可能面临市场波动，系统在周末休市前半小时至周一开市后半小时内，维持保证金比例调整为100%阶段建议客户保留足够保证金以免交易单因市况波动被强制平仓。 <br>请留意：高杠杆保证金账户的强平比例在30%。",
        },
        {
          tag: " 汇率",
          tab: false,
          desc: " 所有非美元存款，均会被兑换成美元。存取款时，本公司将按照相应的市场汇率为客户兑换相应币种。客户同意本公司按所提供之市场汇率进行兑换相应币种。",
        },
        {
          tag: "交易编码 ",
          tab: false,
          desc: " Ⅰ.本公司提供建仓及平仓交易编码。<br> Ⅱ.建仓/平仓交易编码和客户之订单号一 一对应，具唯一性。<br>  Ⅲ.公司根据香港黄金交易所的交易编码费用收取相关费用,收费详情如下:<br> <table class='conTable'>  <tbody><tr><td>交易手数</td><td>收费标准</td></tr>  <tr><td>0.1手至小于1手</td><td>每0.1手0.12美元</td></tr> <tr><td>1手或以上</td><td>每1手1.5美元</td></tr>  </tbody></table> IV.客户于凌晨00:00 - 05:59（冬令时）或00:00 - 04:59（夏令时），建仓/平仓的订单，须于当天早上11:30前完成申请；而其他常规订单，须于次日凌晨05:30前（冬令时）或次日04:30（夏令时）前完成申请。另须留意，周末及节假日休市期间无法提交申请。<br>  V.客户如需要交易编码服务，您可以咨询客服或登录网站用户中心或APP后自助申请，费用将从交易账户余额中扣除。 <br>",
        },
        {
          tag: "优惠 ",
          tab: false,
          desc: "香港金盛贵金属对提供给客户的优惠拥有解释权，并对客户是否享有优惠及优惠的数额有决定权。 ",
        },
        {
          tag: " 异常交易的处理方法",
          tab: false,
          desc:
            "为建立并提供一个公平及公正的交易平台让客户进行交易，公司将对客户的交易账户内出现的，包括但不限于以下异常交易活动做出进一步审核：<br> 1.  于180秒或以内完成开仓平仓活动；<br>" +
            "2.使用恶意交易或外挂软件，同一账户、同一时间做出大量交易，总数超过任何产品的单一交易上限；<br>3.  使用同一装置并以多个不同账户进行高频交易；<br> 4.  透过影响国际市场价格导致该产品出现急剧波动而非法获利者；<br> 5.  以不同交易账户作不同方向交易对冲。<br>6.突然间的大量交易，例如从0.01手突然变成5-10手左右的交易。<br>" +
            "因不正当交易（如恶意炒作以赚取佣金等）的行为将会对市场、平台及其他客户构成不公平情况并影响交易系统的稳定性及效率 ，本公司特此郑重申明，" +
            "不允许客户利用交易账户做出任何不正当交易。如交易账户中出现以上一条或多条异常交易情况，本公司风控部门会对该交易账户进行审核，审核期间会对异常交易的账户作出3个月的冻结处理，被冻结之账户持有人将会收到公司发出的账户冻结通知邮件或短信。账户冻结期间，公司将暂停受理该账户之任何业务、亦不可进行任何交易，直至冻结期完结，" +
            "公司将会按照审核结果进行解冻或不正当交易的处理。若发现相关交易属于不正当交易，公司将采取下列处理方式：<br>1.  审核周期内的交易单亏损额度达到交易本金6%或以上，不作任何处理，客户的取款金额将发放给客户；<br>2.  审核周期内的交易单亏损额度低于交易本金的6%，我们" +
            "会收取取款金额的6%作为异常交易产生的成本费用，扣除手续费之后的余额将发放给客户；<br>3.  审核周期内的交易单是盈利的，我们会扣除所有盈利并会收取取款金额的6%作为异常交易产生的成本费用，再将余额发放给客户。<br>如遇上述定义以外的疑似异常交易之账户，公司将可能在进一步审核后将其列入冻结名单。本公司保留最终的解释及更改上述任何条款与细则的权利。<br> ",
        },
      ],
    };
  },
  components: {
    "app-subHeader": subHeader,
  },
};
</script>
<style>
.conTable td {
  width: 32%;
}
</style>



// WEBPACK FOOTER //
// src/components/trade/Rules.vue